<template>
  <product-variant-selection
    v-if="product"
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    as-form
    :attribute-selection-labels
    :error
    :get-attr-option-available
    :get-attr-option-notify-me
    :handle-next-attribute
    :inventory
    :is-coming-soon
    :pending
    :product
    :reviews-data
    :selected-variant
    @select-color="selectColor"
    @select-size="selectSize"
  >
    <slot />
  </product-variant-selection>
</template>

<script lang="ts" setup>
defineSlots<{
  default: () => void
}>()

const {
  attributeSelection,
  attributeSelectionFormRef,
  attributeSelectionLabels,
  error,
  handleNextAttribute,
  inventory,
  isComingSoon,
  getAttrOptionAvailable,
  getAttrOptionNotifyMe,
  pending,
  product,
  reviewsData,
  selectColor,
  selectSize,
  selectedVariant
} = usePdp()
</script>
